import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import moment from 'moment';

import { getBusinessGroupList } from "../../../modules/businessGroup";
import { getGames } from "../../../modules/system/game";
import { upsertTournament, getTournamentDates } from "../../../modules/tournament";
import { tournamentDialogDisplay } from "./tournament-field-mapper";

import { EyeIcon, ChevronDownIcon } from "@heroicons/react/outline";
import MarkdownIt from "markdown-it";
import markdownItModifyToken from "markdown-it-modify-token";
import MdEditor from "react-markdown-editor-lite";
import {modifyToken} from "../../../services/utils/modifyToken";
import "react-markdown-editor-lite/lib/index.css";
import "react-datepicker/dist/react-datepicker.css";
import "./tournament-editor.css";
import {toast} from "react-toastify";

import DatePicker from "react-datepicker";

import TournamentDialog from "../tournaments/tournament-dialog";

const mdParser = new MarkdownIt({ typographer: true, modifyToken });
mdParser.use(markdownItModifyToken);
const MAX_CHARACTERS = 100;
const MILISECONDS_IN_A_DAY = 24*60*60*1000;
const EDIT_TOURNAMENT_TITLE = "Edit Tournament";
const CREATE_TOURNAMENT_TITLE = "Create New Tournament";

class TournamentEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      description: "",
      navigate: "",

      businessGroupValidMsg: "",
      gameValidMsg: "",
      titleValidMsg: "",
      startDateValidMsg: "",
      endDateValidMsg: "",

      renderPreviewDialog: false,
      otherTournamentsDates: [],
      allTournamentsDates: [],

      tournament: {
        tournamentName: "",
        startDate: Date.now(),
        endDate: Date.now(),
        tournamentDescription: "",
        businessGroupId: 0,
        businessGroupName: "",
        gameId: 0,
        gameName: "",
      },
      validationError: null,
    };

    this.handleChangedValues = this.handleChangedValues.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.submitTournamentData = this.submitTournamentData.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    console.log(" ~~~ TournamentEditor.compnentDidmount")
    if (typeof this.props.match.params.tournamentId !== "undefined") {
      console.log(EDIT_TOURNAMENT_TITLE)
      console.log(this.props.match.params.tournamentId)
      const { tournament } = this.props;
      this.setState({ ...this.state, tournament, title: EDIT_TOURNAMENT_TITLE});
      this.getTournamentDates(tournament.businessGroupId);
    }else{
      console.log(CREATE_TOURNAMENT_TITLE)
      this.setState({ ...this.state, title: CREATE_TOURNAMENT_TITLE});
    }
    dispatch(getBusinessGroupList([], "group_name"));
    dispatch(getGames([], "name"));
  }

  handleChangedValues(event) {
    if (event.target && event.target.id) {
      if (event.target.id === "TournamentBuisnessGroupId") {
        this.getTournamentDates(event.target.value);

        this.setState({
          ...this.state,
          tournament: {
            ...this.state.tournament,
            businessGroupId: event.target.value,
            businessGroupName:
              event.target.options[event.target.selectedIndex].text,
          },
        });
      }
      else if (event.target.id === "TournamentGameSelectedId") {
        this.setState({
          ...this.state,
          tournament: {
            ...this.state.tournament,
            gameId: event.target.value,
            gameName: event.target.options[event.target.selectedIndex].text,
          },
        });
      }
      else if (event.target.id === "TournamentNameId") {
        this.setState({
          ...this.state,
          tournament: {
            ...this.state.tournament,
            tournamentName: event.target.value,
          },
        });
      }
    }
    else {
      this.setState({
        ...this.state,
        tournament: {
          ...this.state.tournament,
          tournamentDescription: event.text,
        },
        tournamentHtml: event.html
      });
    }
  }

  setStartDate(newStartDate) {
    if (!newStartDate) {
      return;
    }

    this.setState({
      ...this.state,
      tournament: {
        ...this.state.tournament,
        startDate: newStartDate.getTime(),
      },
    });
  }

  setEndDate(newEndDate) {
    if (!newEndDate) {
      return;
    }

    this.setState({
      ...this.state,
      tournament: {
        ...this.state.tournament,
        endDate: newEndDate.getTime(),
      },
    });
  }

  async validateFields() {
    const { tournament } = this.state;

    var businessGroupValidMsg = "", gameValidMsg = "", titleValidMsg = "";

    if (parseInt(tournament.businessGroupId, 10) === 0 || tournament.businessGroupId === undefined) {
      businessGroupValidMsg = "Select business group";
    }

    if (parseInt(tournament.gameId, 10) === 0 || tournament.gameId === undefined) {
      gameValidMsg = "Select game";
    }

    if (tournament.tournamentName.length <= 0 || tournament.tournamentName === "" ||
      tournament.tournamentName === undefined) {
      titleValidMsg = "Title can not have less than 0 characters";
    }
    else if (tournament.tournamentName.length > MAX_CHARACTERS) {
      titleValidMsg = `Title can not have more than ${MAX_CHARACTERS} characters`;
    }

    //////////// DATES VALIDATIONS ////////////

    var endDateValidMsg = "";
    var now = Date.now();

    var timestampStartDate = tournament.startDate;
    if (typeof timestampStartDate === "object") {
      timestampStartDate = timestampStartDate.getTime();
    }

    var timestampEndDate = tournament.endDate;
    if (typeof timestampEndDate === "object") {
      timestampEndDate = timestampEndDate.getTime();
    }

    if (timestampEndDate <= timestampStartDate) {
      endDateValidMsg = "End date must be after start date";
    }
    else if (now >= timestampStartDate && now >= timestampEndDate) {
      endDateValidMsg = "End date must be after current time";
    }

    if (!businessGroupValidMsg && !gameValidMsg && !titleValidMsg && !endDateValidMsg) {
      this.setState({
        ...this.state,
        businessGroupValidMsg: "",
        gameValidMsg: "",
        titleValidMsg: "",
        endDateValidMsg: "",
        validationError: "",
        tournament: {
          ...this.state.tournament,
          startDate: timestampStartDate,
          endDate: timestampEndDate,
        },
      });
      return true;
    } else {
      this.setState({
        ...this.state,
        businessGroupValidMsg,
        gameValidMsg,
        titleValidMsg,
        endDateValidMsg,
        validationError: "",
        tournament: {
          ...this.state.tournament,
          startDate: timestampStartDate,
          endDate: timestampEndDate,
        },
      });
      return false;
    }
  }

  async submitTournamentData(e) {
    e.preventDefault();
    if(await this.validateAndRecordTournament())
    {
      this.setState({ ...this.state, navigate: "/tournament" });
    }
  }

  async createPlusNew(e){
    e.preventDefault()
    if(await this.validateAndRecordTournament())
    {
      let { tournament } = this.state;
      tournament.startDate += MILISECONDS_IN_A_DAY;
      tournament.endDate += MILISECONDS_IN_A_DAY;
      tournament.gameId = 0;
      tournament.gameName = "";
      delete tournament["tournamentId"]
      this.setState({...this.state, tournament, title: CREATE_TOURNAMENT_TITLE})
    }
  }

  async validateAndRecordTournament(){
    const { token } = this.props;

    var isFieldsValid = await this.validateFields();

    const _tournament = { ...this.state.tournament };

    if (isFieldsValid) {
      try {
        await upsertTournament(token, _tournament);
        toast.success(
          `${_tournament.gameName} tournament on ${moment(_tournament.startDate).format("LLL")} at ${_tournament.businessGroupName} created successfully.`,
          {position: toast.POSITION.TOP_CENTER}
          )
        return true;
      } catch (e) {
        console.error(e);
        if (e.response && e.response.data) {
          let validationError = { ...e.response.data };
          delete validationError["new_auth"];
          this.setState({
            ...this.state,
            validationError,
            businessGroupValidMsg: "",
            gameValidMsg: "",
            titleValidMsg: "",
            endDateValidMsg: "",
          });
        }
      }
    }
    return false; 
  }

  mapTheDates() {
    const { otherTournamentsDates } = this.state;

    var arr = [];

    for (let i = 0; i < otherTournamentsDates.length; i++) {
      var newStartDate = new Date(otherTournamentsDates[i]["start_time"]);
      var newEndDate = new Date(otherTournamentsDates[i]["end_time"]);
      var diffBetweenTheDates = new Date(newEndDate - newStartDate).getDate();

      for (let j = 0; j < diffBetweenTheDates; j++) {
        var nextDay = new Date(newStartDate);
        nextDay.setDate(newStartDate.getDate() + j);
        arr.push(nextDay);
      }
    }

    this.setState({
      ...this.state,
      allTournamentsDates: arr
    });
  }

  async getTournamentDates(businessGroupId = 0) {
    const { token } = this.props;

    try {
      const response = await getTournamentDates(token, businessGroupId);
      this.setState({ ...this.state, otherTournamentsDates: response.data.dates });
      this.mapTheDates();
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const { businessGroups, games, token } = this.props;
    const {
      navigate,
      tournament,
      businessGroupValidMsg,
      gameValidMsg,
      titleValidMsg,
      startDateValidMsg,
      endDateValidMsg,
      renderPreviewDialog,
      validationError,
      allTournamentsDates,
      title,
    } = this.state;
    const _games = [
      { id: 0, name: "Select Game" },
      ...games.filter((g) => !g.archived),
    ];
    const _businessGroups = [
      { id: 0, group_name: "Select Business Group" },
      ...businessGroups,
    ];
    if (navigate !== "") {
      return <Redirect to={navigate} />;
    }
    return (
      <div className="tw-mx-10 tw-my-5 tw-container tw-text-left" >
        <h1 className="tw-font-extrabold tw-text-2xl">{title}</h1>
        <form
          className="tw-w-full tw-max-w-2xl tw-mt-5"
          onSubmit={(e) => this.submitTournamentData(e)}
        >
          <div className="tw-form-row">
            <div className="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
              <label className="tw-form-label" htmlFor="grid-business-group">
                Buisness group
              </label>
              <div className="tw-relative">
                <select
                  id="TournamentBuisnessGroupId"
                  className={
                    businessGroupValidMsg
                      ? "tw-form-input-invalid tw-form-input"
                      : "tw-form-input-default tw-form-input"
                  }
                  onChange={this.handleChangedValues}
                  value={tournament.businessGroupId}
                >
                  {_businessGroups.map((bg, i) => (
                    <option key={bg.id} value={bg.id}>
                      {bg.group_name}
                    </option>
                  ))}
                </select>
                <div className="tw-form-icon-input-overlay">
                  <ChevronDownIcon className="tw-h-6 tw-w-6" />
                </div>
              </div>
              {businessGroupValidMsg && (
                <p className="tw-text-red-500 tw-text-s tw-italic">
                  {businessGroupValidMsg}
                </p>
              )}
            </div>
            <div className="tw-w-full md:tw-w-1/2 tw-px-3">
              <label className="tw-form-label" htmlFor="grid-game">
                Game
              </label>
              <div className="tw-relative">
                <select
                  id="TournamentGameSelectedId"
                  className={
                    gameValidMsg
                      ? "tw-form-input-invalid tw-form-input tw-block"
                      : "tw-form-input-default tw-form-input tw-block"
                  }
                  onChange={this.handleChangedValues}
                  value={tournament.gameId}
                >
                  {_games.map((g, i) => (
                    <option key={g.id} value={g.id}>
                      {g.name}
                    </option>
                  ))}
                </select>
                <div className="tw-form-icon-input-overlay">
                  <ChevronDownIcon className="tw-h-6 tw-w-6" />
                </div>
              </div>
              {gameValidMsg && (
                <p className="tw-text-red-500 tw-text-s tw-italic">
                  {gameValidMsg}
                </p>
              )}
            </div>
          </div>
          <div className="tw-form-row">
            <div className="tw-w-full tw-px-3">
              <label className="tw-form-label" htmlFor="grid-game">
                Title
              </label>
              <input
                id="TournamentNameId"
                className={
                  titleValidMsg
                    ? "tw-form-input-invalid tw-form-input"
                    : "tw-form-input-default tw-form-input"
                }
                value={tournament.tournamentName}
                onChange={this.handleChangedValues}
              />
              {titleValidMsg && (
                <p className="tw-text-red-500 tw-text-s tw-italic">
                  {titleValidMsg}
                </p>
              )}
            </div>
          </div>
          <div className="tw-flex tw-flex-wrap tw--mx-3 tw-mb-3">
            <div className="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
              <label className="tw-form-label" htmlFor="grid-start-time">
                Start Date
              </label>
              <DatePicker
                className={
                  startDateValidMsg
                    ? "tw-form-input-invalid tw-form-input tw-block"
                    : "tw-form-input-default tw-form-input tw-block"
                }
                showTimeSelect
                dateFormat="Pp"
                selected={tournament.startDate}
                onChange={(date) => this.setStartDate(date)}
                excludeDates={allTournamentsDates}
              ></DatePicker>
              {startDateValidMsg && (
                <p className="tw-text-red-500 tw-text-s tw-italic">
                  {startDateValidMsg}
                </p>
              )}
              {validationError && (
                <p className="tw-text-red-500 tw-text-s tw-italic">
                  {validationError.description}
                </p>
              )}
            </div>
            <div className="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
              <label className="tw-form-label" htmlFor="grid-start-time">
                End Date
              </label>
              <DatePicker
                className={
                  endDateValidMsg
                    ? "tw-form-input-invalid tw-form-input tw-block"
                    : "tw-form-input-default tw-form-input tw-block"
                }
                showTimeSelect
                dateFormat="Pp"
                selected={tournament.endDate}
                onChange={(date) => this.setEndDate(date)}
                excludeDates={allTournamentsDates}
              ></DatePicker>
              {endDateValidMsg && (
                <p className="tw-text-red-500 tw-text-s tw-italic">
                  {endDateValidMsg}
                </p>
              )}
            </div>
          </div>
          <div className="tw-form-row">
            <div className="tw-w-full tw-px-3">
              <label className="tw-form-label" htmlFor="grid-start-time">
                Description (markup)
              </label>
              <MdEditor
                id="TournamentDescriptionId"
                style={{ height: "300px" }}
                renderHTML={(text) => mdParser.render(text)}
                value={tournament.tournamentDescription}
                onChange={({ text, html }) => this.handleChangedValues({ text, html })}
              />
            </div>
          </div>
          <div className="tw-form-row">
            <div className="tw-w-full tw-px-3">
              <button
                className="tw-btn tw-btn-secondary tw-float-right tw-mx-2"
                onClick={() =>
                  this.setState({ ...this.state, navigate: "/tournament" })
                }
              >
                Cancel
              </button>
              <button className="tw-btn tw-btn-primary tw-float-right">
                Submit
              </button>
              <button className="tw-btn tw-btn-success tw-float-right tw-mx-2"
                onClick={(e)=>this.createPlusNew(e)}>
                {(typeof tournament.tournamentId !== "undefined")?"Update":"Create"} + New
              </button>
              <button
                className="tw-btn tw-btn-secondary tw-float-right"
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({ ...this.state, renderPreviewDialog: true });
                }}
                disabled = {!tournament.gameId || !tournament.businessGroupId}
              >
                Preview&nbsp;
                <EyeIcon className="tw-h-5 tw-w-5" />
              </button>
            </div>
          </div>
        </form>
        {renderPreviewDialog ? (
          <TournamentDialog
            hide_func={() =>
              this.setState({ ...this.state, renderPreviewDialog: false })
            }
            tournament_data={tournamentDialogDisplay(tournament)}
            show={true}
            token={token}
          />
        ) : null}
      </div >
    );
  }
}

const emptyTournament = {
  tournamentName: "",
  startDate: Date.now(),
  endDate: Date.now(),
  tournamentDescription: "",
  businessGroupId: 0,
  businessGroupName: "",
  gameId: 0,
  gameName: "",
};

const withState = connect((state, props) => {
  const { tournament, game, business_group, user } = state;
  const { params } = props.match;
  let _state = {};

  if (typeof params.tournamentId !== "undefined") {
    let _tournament = tournament.tournaments.filter(
      (t) => t.tournamentId === parseInt(params.tournamentId, 10)
    );
    _tournament = _tournament.length > 0 ? _tournament[0] : emptyTournament;

    _state = {
      tournament: {
        ..._tournament,
      },
    };
  }
  else {
    _state = {
      tournament: emptyTournament,
    };
  }
  _state = {
    ..._state,
    games: game.games,
    businessGroups: business_group.business_groups,
    token: user.token,
  };
  return _state;
});

export default withState(TournamentEditor);



// WEBPACK FOOTER //
// ./src/components/containers/tournament-creator/tournament-editor.js